import React from 'react'

/**
 * Os ícones do KIT do evento, recortados das folhas `static/img/icons-*.png`.
 *
 * ═══ POR QUE RASTER E NÃO SVG ═══
 *
 * A página desenhava tudo com traço Tabler inline: correto, leve, recolorível.
 * Mas o kit gráfico entregue pelo cliente traz os ícones como DISCOS DE NEON
 * com halo, reflexo no vidro e o logo da Apresenta.me embutido em vários deles
 * — e isso não se reproduz com `stroke: currentColor`. Enquanto o site usou o
 * traço, ele parecia um site sobre o evento; com os discos, ele parece o
 * evento.
 *
 * O custo é honesto e medido: 25 arquivos, 192px no lado maior, quantizados a
 * 48 cores sem dither, ~30-40KB cada, `loading="lazy"` em todos menos os do
 * hero. A folha original de onde saíram tem 1254px e 1,5-3,8MB — as nove folhas
 * juntas pesam 38MB e saem de `static/` no fim do trabalho, porque nenhuma é
 * referenciada depois do recorte.
 *
 * ⚠️ SEM DITHER é o truque do tamanho, não detalhe de gosto: o ruído de
 * Floyd-Steinberg é justamente o que impede o PNG de comprimir, e com dither
 * ligado os mesmos arquivos dobram de peso. Mesma receita dos mascotes
 * `nauta-rota-*`.
 *
 * ═══ ACESSIBILIDADE ═══
 *
 * `alt=""` e `aria-hidden` por padrão: em todos os usos da página o ícone
 * acompanha um rótulo em texto ao lado, então descrevê-lo faria o leitor de
 * tela anunciar a mesma informação duas vezes. Quem precisar de um ícone que
 * carregue significado sozinho passa `alt` explícito.
 */

/* As proporções reais de cada recorte, para reservar a caixa antes de a imagem
   chegar. Sem isto a página salta quando os ícones decodificam — CLS de graça
   numa dobra cheia deles. */
const DIMENSOES = {
  'ico-alvo': [192, 188],
  'ico-aperto': [192, 157],
  'ico-bandeira': [192, 182],
  'ico-barras': [192, 189],
  'ico-calendario': [192, 190],
  'ico-casa': [190, 192],
  'ico-check': [177, 192],
  'ico-chip': [191, 192],
  'ico-cifrao': [190, 192],
  'ico-diamante': [188, 183],
  'ico-engrenagem': [191, 192],
  'ico-foguete': [175, 192],
  'ico-grupo': [192, 188],
  'ico-headset': [191, 192],
  'ico-interrogacao': [178, 192],
  'ico-logo': [185, 192],
  'ico-mira': [169, 192],
  'ico-pessoa': [192, 182],
  'ico-pessoas': [192, 149],
  'ico-pino': [146, 192],
  'ico-pino-logo': [159, 192],
  'ico-pino-simples': [155, 192],
  'ico-predio': [191, 192],
  'ico-relogio': [171, 192],
  'ico-relogio-fino': [174, 192],
}

export default function IconeArte({ nome, className = '', alt = '', ...resto }) {
  const [largura, altura] = DIMENSOES[nome] || [192, 192]
  return (
    <img
      src={`/img/${nome}.png`}
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      width={largura}
      height={altura}
      loading="lazy"
      decoding="async"
      className={`icone-arte ${className}`.trim()}
      {...resto}
    />
  )
}
